/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OrderCancellationPolicyActionType } from '../models/OrderCancellationPolicyActionType';
import type { OrderCancellationPolicyAdminDto } from '../models/OrderCancellationPolicyAdminDto';
import type { Pagination1OfOrderCancellationPolicyActionLogAdminDto } from '../models/Pagination1OfOrderCancellationPolicyActionLogAdminDto';
import type { PostPutOrderCancellationPolicyRequestAdmin } from '../models/PostPutOrderCancellationPolicyRequestAdmin';
import type { PutOrderCancellationPolicyStatusRequestAdmin } from '../models/PutOrderCancellationPolicyStatusRequestAdmin';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class OrderCancellationPoliciesService {
    /**
     * **Required Policy:** `ViewPanelSettings`
     * @returns OrderCancellationPolicyAdminDto OK
     * @throws ApiError
     */
    public static getPoliciesAdmin(): CancelablePromise<Array<OrderCancellationPolicyAdminDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/ordercancellationpolicies',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManagePanelSettings`
     * @returns OrderCancellationPolicyAdminDto Created
     * @throws ApiError
     */
    public static createPolicyAdmin({
        requestBody,
    }: {
        requestBody?: PostPutOrderCancellationPolicyRequestAdmin,
    }): CancelablePromise<OrderCancellationPolicyAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/ordercancellationpolicies',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewPanelSettings`
     * @returns OrderCancellationPolicyAdminDto OK
     * @throws ApiError
     */
    public static getPolicyByIdAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<OrderCancellationPolicyAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/ordercancellationpolicies/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManagePanelSettings`
     * @returns OrderCancellationPolicyAdminDto OK
     * @throws ApiError
     */
    public static updatePolicyAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PostPutOrderCancellationPolicyRequestAdmin,
    }): CancelablePromise<OrderCancellationPolicyAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/ordercancellationpolicies/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManagePanelSettings`
     * @returns any OK
     * @throws ApiError
     */
    public static deletePolicyAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/ordercancellationpolicies/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManagePanelSettings`
     * @returns OrderCancellationPolicyAdminDto OK
     * @throws ApiError
     */
    public static updatePolicyStatusAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutOrderCancellationPolicyStatusRequestAdmin,
    }): CancelablePromise<OrderCancellationPolicyAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/ordercancellationpolicies/{id}/status',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewPanelSettings`
     * @returns Pagination1OfOrderCancellationPolicyActionLogAdminDto OK
     * @throws ApiError
     */
    public static getHistoryAdmin({
        fromDate,
        toDate,
        branchId,
        policyId,
        actionType,
        escalationMatched,
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        fromDate?: string,
        toDate?: string,
        branchId?: number,
        policyId?: number,
        actionType?: OrderCancellationPolicyActionType,
        escalationMatched?: boolean,
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<Pagination1OfOrderCancellationPolicyActionLogAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/ordercancellationpolicies/history',
            query: {
                'fromDate': fromDate,
                'toDate': toDate,
                'branchId': branchId,
                'policyId': policyId,
                'actionType': actionType,
                'escalationMatched': escalationMatched,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
